import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';

/**
 * "Full view" — opens a data-heavy table on its own dedicated page, where the
 * table is the only thing on screen and can therefore afford many more rows
 * per page.
 *
 * This is purely an extra way in. The embedded table keeps its own page size,
 * filters and pagination exactly as they were; nothing about the dashboard
 * changes. The dedicated routes are deliberately absent from sitemap.js — you
 * arrive from this button, never from the nav.
 */
const TableExpandButton = ({ to, label = 'Full view', className = '' }) => (
  <Link
    to={to}
    className={`btn btn-phoenix-secondary btn-sm ${className}`.trim()}
    title="Open this table on its own page — same data, many more rows per page"
  >
    <FontAwesomeIcon
      icon={faUpRightAndDownLeftFromCenter}
      className="me-2 fs-10"
    />
    {label}
  </Link>
);

export default TableExpandButton;
